// component name
$component: 'zr-bannerx-hero';

.#{$component}__image {
    max-width: 100%;
    min-width: 100%;
    height: auto;
}

.#{$component}__badge {
    background-color: var(--ci-neutral800);
    border-bottom-left-radius: 8px;
    color: #fff;
    font-weight: 600;
    padding: 4px 8px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
}
